<template>
  <div class="animated fadeIn">
  	<div class="modal fade show" id="modalBaixa" tabindex="-1" role="dialog" 
      aria-labelledby="myModalLabel" aria-hidden="false" data-keyboard="false" 
      data-backdrop="static" v-if="showModalNovoCompromisso">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title">Novo Compromisso</h4>
					</div>
					<div class="modal-body">
						<input type="hidden"  v-model="model.id" />
						<div class="row">
							<div class="col-md-4">
								<label>Data e Hora inicio:</label><br>
								<input class="data form-control" v-model="model.dataHoraInicio" required="required" />
							</div>
							<div class="col-md-4">
								<label>Data e Hora final:</label><br>
								<input class="data form-control" v-model="model.dataHoraFinal" required="required" />
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<label>Titulo:</label><br>
								<input class="form-control" v-model="model.titulo" required="required" />
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<label>Local:</label><br>
								<input class="form-control" v-model="model.local" />
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<label>Descrição:</label><br>
								<input class="form-control" v-model="model.descricao" />
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<label>Usuário:</label><br>
								<select class="pula form-control custom" v-model="model.usuarioId">
									<options items="${usuarios}" itemValue="id" itemLabel="nome" />
								</select>
							</div>
						</div>

						<div class="row">
							<div class="col-md-4">
								<label>Exibir Como:</label><br>
								<select class="pula form-control custom" v-model="model.exibirComo">
									<option value="O"  label="Ocupado" />
									<option value="A"  label="Ausente" />
								</select>
							</div>
							<div class="col-md-4">
								<label>Visível Para:</label><br>
								<select class="pula form-control custom" v-model="model.visivelPara">
									<option value="T"  label="Todos">Todos</option>
									<option value="S"  label="Somente Usuário" />
								</select>
							</div>
						</div>
						<div class="row">
							<div class="col-md-4">
								<label>Cor:</label><br>
								<div id="colorPicker">
					        <a class="color"><div class="colorInner"></div></a>
					        <div class="track"></div>
					        <ul class="dropdown"><li></li></ul>
					        <input type="hidden"  class="colorInput form-control" v-model="model.cor" />
						    </div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<div class="col-md-2">
							<a id="excluir" href="#" class="btn btn-danger pull-left">Excluir</a>
						</div>
						<div class="col-md-10">
							<input class="btn btn-success" type="submit" value="Salvar">
							<a href="<c:url value="/agenda" />" class="btn btn-warning">Fechar</a>
						</div>
					</div>
				</div>
			</div>	
		</div>

    <div class="col-sm-12 col-md-12">
      <div class="card">
        <div class="card-body">
          <div id="titulo" class="panel panel-default">
            <!-- Default panel contents -->
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12">
                  <h4>Agenda</h4>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
									<div class="conteudo barra-ferramentas">
										<button id="novoCompromisso" type="button" class="btn btn-success" v-on:click="showModalNovoCompromisso = true">
											<span class="glyphicon glyphicon-plus"></span> Novo Compromisso
										</button>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-12 col-md-12">
									<div id="dadoss">
										<br>
										<full-calendar :events="fcEvents" locale="pt-br"></full-calendar>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import axios from 'axios'
import fullCalendar from 'vue-fullcalendar'
export default {
  data () {
    return {
      dadosTabela: [],
      model: {
        id: '',
        dataHoraInicio: '',
        dataHoraFinal: '',
        titulo: '',
        local: '',
        descricao: '',
        usuarioId: '',
        exibirComo: '',
        visivelPara: '',
        cor: ''
      },
      fcEvents: [],
      showModalNovoCompromisso: false
    }
  },
  created: function () {
    this.buscar()
  },
  components: {
    fullCalendar
  },
  mounted: function () {
    $('.pula').keypress(function (e) {
      var tecla = (e.keyCode ? e.keyCode : e.which)
      if (tecla === 13) {
        let campo = $('.pula')
        let indice = campo.index(this)
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus()
        }
        if (campo[indice + 1] != null) {
          let proximo = campo[indice + 1]
          proximo.focus()
        }
        e.preventDefault(e)
        return false
      }
    })
  },
  methods: {
    buscar: function () {
      var self = this
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/bancos?buscas='
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosTabela = dadosCadastro.dados
      })
    },
    editar: function (id) {
      this.$router.replace('/bancos/editar/' + id)
    },
    deletar: function (id) {
      let message = 'Are you sure?'
      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'Continue',
        cancelText: 'Close',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'basic', // coming soon: 'soft', 'hard'
        verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
        clicksCount: 3 // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
      }
      this.$dialog.confirm(message, options)
      .then(function () {
        console.log('Clicked on proceed')
      })
      .catch(function () {
        console.log('Clicked on cancel')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/agenda/Agenda.vue